import time from 'jt-time'
import consts from '@/utils/consts'
import helpers from '@/utils/helpers/base'
import auth from '@/utils/auth'
import globalMixin from '@/mixins/global'
import Products from '@/components/details_figure/products'
import ProductsMob from '@/components/details_figure_mobile/products_sub'
import Technicals from '@/components/details_figure/technical'
import TechnicalsMob from '@/components/details_figure_mobile/technical_sub'
import Solutions from '@/components/details_figure/solution'
import SolutionsMob from '@/components/details_figure_mobile/solution_sub'
import Intros from '@/components/details_figure/intros'
import IntrosMob from '@/components/details_figure_mobile/intros_sub'

export default {
  install (Vue) {
    Vue.prototype.$time = time
    Vue.prototype.$consts = consts
    Vue.prototype.$helpers = helpers
    Vue.prototype.$auth = auth

    Vue.filter('time', val => time.getTime(val))
    Vue.filter('date', val => time.getDate(val))
    Vue.filter('itemById', (items, id) => helpers.getItemById(items, id))

    Vue.mixin(globalMixin)

    Vue.component('Products', Products)
    Vue.component('Technicals', Technicals)
    Vue.component('Solutions', Solutions)
    Vue.component('Intros', Intros)
    Vue.component('IntrosMob', IntrosMob)
    Vue.component('ProductsMob', ProductsMob)
    Vue.component('TechnicalsMob', TechnicalsMob)
    Vue.component('SolutionsMob', SolutionsMob)
  }
}
